import React, { useState, useContext } from 'react';
import { Heading } from '@superops/ui-design-system';
import {
  Icon,
  NewTask,
  BackgroundIcon,
  AccessControl,
  toast,
  ERROR_CODES,
  Tag,
  getTranslatedText,
  B1,
  Row,
  EventEmitterWithIndex
} from '@nile/components';
import { CalendarCheck, Stopwatch } from '@styled-icons/fa-solid';
import { TicketClient, UPDATE_TASK, DELETE_TASK } from '@nile/graphql';
import { GET_PROJECT } from '@nile/projects/src/Graphql';
import { PROJECT_STATUSES } from '@nile/projects/src/Components/Cards/ProjectListItem';
import { constructTaskObject, renderTime } from '@nile/projects/src/Utils';
import StatusHolder from '@nile/projects/src/Components/Elements/StatusHolder';

import styled from 'styled-components';
import { cloneDeep } from 'lodash';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const EstimateIconWrapper = styled.div`
  opacity: 0.6;
  margin-right: 10px;
`;

const TaskItemHolder = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 10px;
`;

const TaskItem = styled.div`
  justify-content: space-between;
  .fend {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

const TaskTitle = ({ task, handleTaskUpdation, project, intl }) => {
  const [sheetActive, setSheetActive] = useState(false);

  const projectContext = useContext(ProjectContext);

  const toggleSheetActive = () => {
    setSheetActive(!sheetActive);
  };

  const deleteTaskHandler = (toggleSheet) => {
    TicketClient.mutate({
      mutation: DELETE_TASK,
      variables: { taskId: task.taskId, module: 'PROJECT' }
    }).then((res) => {
      if (res?.data?.deleteTask) {
        toast(
          'success',
          getTranslatedText(intl, 'ticket.details.task.delete.success')
        );
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        if (toggleSheet) {
          toggleSheetActive();
        }
      }
    });
  };

  return (
    // <AccessControl
    //   reference={projectContext.features}
    //   roleToCheck="task.edit"
    //   render={
    //     <NewTask
    //       addOrUpdateTechGroup={(type, taskObj) =>
    //         handleTaskUpdation(task.taskId, taskObj, toggleSheetActive)
    //       }
    //       state={sheetActive}
    //       toggleSheetActive={toggleSheetActive}
    //       name={task.title}
    //       hideIcon
    //       isLink
    //       data={task}
    //       module="PROJECT_TASK"
    //       details={
    //         task?.taskId
    //           ? {
    //               operation: 'UPDATE',
    //               projectId: project?.projectId,
    //               taskId: task?.taskId
    //             }
    //           : {
    //               operation: 'CREATE',
    //               projectId: project?.projectId
    //             }
    //       }
    //       className="ta-l"
    //       onDeleteHandler={() => deleteTaskHandler(true)}
    //     />
    //   }
    //   fallback={<div>{task.title}</div>}
    // />
    <>
      <NewTask
        addOrUpdateTechGroup={(type, taskObj) =>
          handleTaskUpdation(task.taskId, taskObj, toggleSheetActive)
        }
        state={sheetActive}
        toggleSheetActive={toggleSheetActive}
        name={task.title}
        hideIcon
        isLink
        data={task}
        module="PROJECT_TASK"
        details={
          task?.taskId
            ? {
                operation: 'UPDATE',
                projectId: project?.projectId,
                taskId: task?.taskId
              }
            : {
                operation: 'CREATE',
                projectId: project?.projectId
              }
        }
        className="ta-l"
        onDeleteHandler={() => deleteTaskHandler(true)}
      />
    </>
  );
};

const MyTasks = (props) => {
  const { intl } = props;

  const isItProduct = useCheckIsItProduct();

  const handleTaskUpdation = (id, task, cb) => {
    const taskObj = constructTaskObject(task);
    TicketClient.mutate({
      mutation: UPDATE_TASK,
      variables: { taskId: id, module: 'PROJECT', input: taskObj }
    })
      .then((res) => {
        if (res?.data?.updateTask) {
          const updatedTasks = cloneDeep(props.tasks);
          const idx = updatedTasks.findIndex((tsk) => tsk.taskId === id);
          updatedTasks[idx] = res.data.updateTask;
          props.setTasks(updatedTasks);
          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.project.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast('success', 'Task updated successfully');
              props.setProject(resp.data.getProject);
              cb();
            }
          });
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  return (
    <div className="actr full-width pr-20 pl20">
      <div className="">
        <div className="fx actr">
          <Heading element="h3">
            <B1>
              <FormattedMessage id="project.view.mytasks" />
            </B1>
          </Heading>
        </div>
        <TaskItemHolder>
          {props?.tasks?.map((task) => (
            <TaskItem className="flex actr tw-gap-1">
              <TaskTitle
                task={task}
                intl={intl}
                handleTaskUpdation={handleTaskUpdation}
                project={props?.project}
              />
              <Row gap={20}>
                <div className="fx uppercase">
                  <Tag
                    active={PROJECT_STATUSES.ACTIVE.includes(
                      task.status ||
                        getTranslatedText(intl, 'project.task.status.planned')
                    )}
                    smooth={PROJECT_STATUSES.NORMAL.includes(
                      task.status ||
                        getTranslatedText(intl, 'project.task.status.planned')
                    )}
                  >
                    {task.status || 'No status'}
                  </Tag>
                </div>
                <div className="fend">
                  <EstimateIconWrapper>
                    <SVGIcon name="EstimatedTime" color="#323232" />
                  </EstimateIconWrapper>
                  {renderTime(task.estimatedTime) || (
                    <div className="disabled">NA</div>
                  )}
                </div>
              </Row>
            </TaskItem>
          ))}
        </TaskItemHolder>
      </div>
    </div>
  );
};

export default injectIntl(MyTasks);
